import message from "antd/es/message";
import { API } from "aws-amplify";
import { getTenant } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";
import { apiClient } from "~/services/apiClient";

// TODO [Translate]
export const EMPTY_TENANT: APITypes.Tenant = {
  id: "",
  authUID: "",
  username: "",
  firstName: "",
  lastName: "",
  email: "",
  status: APITypes.TenantStatusType.InActive,
  createdAt: "",
  updatedAt: "",
  __typename: "Tenant",
  _version: 0,
  _lastChangedAt: 0,
};

export interface FirestoreTenantProfile {
  id: string;
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;
  profilePictureUrl?: string;
}

export interface TenantInfoLoaderResult {
  tenant: APITypes.Tenant;
  profile: FirestoreTenantProfile | null;
}

export type TenantInfoFromApiResult = LoaderData<APITypes.Tenant> & {
  profile: FirestoreTenantProfile | null;
};

export const getTenantInfo = async (
  id: string
): Promise<LoaderData<APITypes.Tenant>> => {
  try {
    const tenantResponse = (await API.graphql({
      query: getTenant,
      variables: {
        id: id,
      },
    })) as { data?: APITypes.GetTenantQuery };

    return {
      success: true,
      data: tenantResponse.data?.getTenant ?? EMPTY_TENANT,
    };
  } catch (error: unknown) {
    const err = error as { message?: string };
    message.error(err.message ?? "Failed to load tenant");
    console.error("get tenant info", error);
    return {
      success: false,
      data: EMPTY_TENANT,
      error,
    };
  }
};

/**
 * Fetch tenant + Firestore profile from Lambda (authenticated by Bearer token).
 */
export const getTenantInfoFromApi = async (): Promise<TenantInfoFromApiResult> => {
  const response = await apiClient.loader<TenantInfoLoaderResult>("tenant-info");
  if (response.success && response.data) {
    return {
      success: true,
      data: response.data.tenant ?? EMPTY_TENANT,
      profile: response.data.profile ?? null,
    };
  }
  return {
    success: false,
    data: EMPTY_TENANT,
    profile: null,
    error: response.error,
  };
};
